import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Button,
  CardContent,
  TextField,
  Typography,
  Stack,
  Avatar,
  MenuItem
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from '../../../Api';
import { useTranslation } from 'react-i18next';
import GooglePlaces from 'src/components/GooglePlaces';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function UserCompanyProfileModal({ handleClose, user, refreshAdmin }) {
  const roleName = user?.role?.role_name;
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [file, setfile] = useState({ image: user?.avatar, file: '' });
  const [name, setname] = useState(user?.name);
  const [about_me, setabout_me] = useState(user?.about_me ? user?.about_me : null);
  const [phone, setPhone] = useState(user?.contact_no ? user?.contact_no : '');
  const [address, setaddress] = useState(null);
  const [nationalitylist, setnationalitylist] = useState([]);
  const [nationality, setnationality] = useState(null);
  const [genderlist, setgenderlist] = useState([]);
  const [gender, setgender] = useState(null);
  useEffect(() => {
    if (user && user?.location) {
      setaddress({
        address: user?.location,
        lat: user?.lat || null,
        lon: user?.lon || null,
        country: user?.country || null,
        city: user?.city || null
      });
    }
  }, []);

  function SaveProfile() {
    const token = localStorage.getItem('token');

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('user_id', user?.id);
    formdata.append('name', name);
    about_me && formdata.append('about_me', about_me);
    phone && formdata.append('contact_no', phone);
    if (address) {
      formdata.append('location', address?.address);
      formdata.append('country', address?.country);
      formdata.append('city', address?.city);
      formdata.append('lat', address?.lat);
      formdata.append('lon', address?.lon);
    }

    if (file && file.file) {
      formdata.append('avatar', file.file);
    }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);

    fetch(api.updateProfile, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);

        if (status === 200 || status === 201) {
          refreshAdmin();
          handleClose();
        } else {
          setalert({ visible: true, message: 'Something went wrong' });
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => setloading(false));
  }

  const [objAfter, setobjAfter] = useState({
    name: user?.name,
    file: false
  });

  const handleNationality = (event) => {
    setnationality(event.target.value);
  };
  const handleGender = (event) => {
    setgender(event.target.value);
  };

  return (
    <Box p={1} mt={2} style={{ width: '100%' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t('Company User Profile')}
      </Typography>

      <CardContent>
        <Stack
          mb={2}
          direction={{ xs: 'column' }}
          style={{ display: 'flex', flexDirection: 'row' }}
          className="image_center"
        >
          <Box
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {file && (
              <Avatar
                alt="Remy Sharp"
                src={objAfter?.file ? file.image : file.image + `?v='${Date.now()}`}
                sx={{ width: 80, height: 80 }}
                className="image_center"
              />
            )}
            <Button
              style={{
                width: !file ? 80 : null,
                height: !file ? 80 : 30,
                borderRadius: !file ? 40 : 20,
                marginTop: 10,
                marginBottom: 10,
                fontSize: 12
              }}
              disabled={roleName?.toLowerCase() == 'user' ? true : false}
              variant={file ? 'outlined' : 'outlined'}
              component="label"
            >
              {t('EditProfile.buttons.0')}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  setobjAfter({
                    file: true
                  });
                  setfile({
                    image: URL.createObjectURL(e.target.files[0]),
                    file: e.target.files[0]
                  });
                }}
              />
            </Button>
          </Box>
        </Stack>
        <Grid container spacing={2} className="top_column">
          <>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                id="outlined-error-helper-text"
                fullWidth
                label={'First Name'}
                type="text"
                value={name}
                onChange={(val) => {
                  setname(val.target.value);
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                id="outlined-error-helper-text"
                fullWidth
                label={'Last Name'}
                type="text"
                value={name}
                onChange={(val) => {
                  setname(val.target.value);
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              {roleName?.toLowerCase() == 'user' ? (
                <TextField
                  disabled={roleName?.toLowerCase() == 'user' ? true : false}
                  fullWidth
                  label={'Residence Location'}
                  value={user?.location}
                  variant="outlined"
                  display="inline"
                />
              ) : (
                <GooglePlaces
                  width="100%"
                  onResult={(val) => {
                    setaddress(val);
                  }}
                  placeholder={'Residence Location'}
                  regions={true}
                  address={address ? address?.address : user?.location}
                />
              )}
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                fullWidth
                select
                value={nationality}
                label={'Nationality'}
                onChange={handleNationality}
                className="width_full_status"
                InputLabelProps={{ shrink: true }} // Correct prop for label shrink
              >
                {nationalitylist?.map((option) => (
                  <MenuItem key={option.id} value={option}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item lg={6} sm={12} md={12} mt={-1}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    fullWidth
                    label="Birth Date"
                    // value={starttime}
                    // onChange={handleStartTimeChange}
                    slotProps={{ textField: { fullWidth: true } }}
                  />
                </DemoContainer>
              </LocalizationProvider>

              {/* <TextField
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                id="outlined-error-helper-text"
                fullWidth
                label={'About Me'}
                type="text"
                value={about_me}
                onChange={(val) => {
                  setabout_me(val.target.value);
                }}
                variant="outlined"
                display="inline"
                multiline
                rows={4}
              /> */}
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                fullWidth
                select
                value={gender}
                label={'Gender'}
                onChange={handleGender}
                className="width_full_status"
                InputLabelProps={{ shrink: true }} // Correct prop for label shrink
              >
                {genderlist?.map((option) => (
                  <MenuItem key={option.id} value={option}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </>
        </Grid>
      </CardContent>

      {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <LoadingButton
          disabled={false}
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={() => {
            SaveProfile();
          }}
          color="primary"
          variant="contained"
        >
          {t('EditProfile.buttons.1')}
        </LoadingButton>
        <LoadingButton
          sx={{
            marginRight: 1
          }}
          onClick={handleClose}
          variant="outlined"
        >
          {t('EditProfile.buttons.2')}
        </LoadingButton>
      </Box>
    </Box>
  );
}
